import ApiService from './../api.service';

export default class MetricsService {}

MetricsService.getAccountsCreated = () => {
  return ApiService.get(`/admin/metrics/accountsCreated`)
}

MetricsService.getJobPostsCreated = () => {
  return ApiService.get(`/admin/metrics/jobPostsCreated`)
}

MetricsService.getJobApplicationCount = () => {
  return ApiService.get(`/admin/metrics/jobApplicationCount`)
}

MetricsService.getCumulativeUserCount = () => {
  return ApiService.get(`/admin/metrics/cumulativeUserCount`)
}
